import { Component, OnInit } from '@angular/core';
import { User } from '../../models/User/user';
import { AppContextService } from '../../services/app-context.service';
import { RouteAuthorizationService } from '../../services/authorization/route-authorization.service';

@Component({
	selector: 'app-financier-companies',
	templateUrl: './financier-companies.component.html',
	styleUrls: ['./financier-companies.component.css'],
	standalone: false,
})
export class FinancierCompaniesComponent implements OnInit {
	private loggedUser: User | null = new User();

	constructor(
		private appContext: AppContextService,
		private routeAuthorizationService: RouteAuthorizationService
	) {}

	ngOnInit(): void {
		this.appContext.getLoggedUserAsync().subscribe((userResult) => {
			this.loggedUser = userResult.Data;

			if (
				!(
					this.loggedUser?.IsSystemAdmin ||
					this.loggedUser?.IsSupportOperator ||
					this.loggedUser?.IsBackOfficeOperator ||
					this.loggedUser?.IsConfirmingBuyer ||
					this.loggedUser?.IsFactoringSupplier
				)
			) {
				this.routeAuthorizationService.routeOnUnauthorized();
			}
		});
	}
}
